export const TECH_CATEGORIES = {
    frontend: { it: 'Frontend', en: 'Frontend' },
    mobile: { it: 'Mobile', en: 'Mobile' },
    desktop: { it: 'Desktop', en: 'Desktop' },
    backend: { it: 'Backend', en: 'Backend' },
    database: { it: 'Database', en: 'Database' },
    service: { it: 'Servizi', en: 'Services' },
};

class Technologies {
    static REACT = { label: 'React JS', category: 'frontend', color: '#61dafb' };
    static HTML = { label: 'HTML', category: 'frontend', color: '#ff6e3d' };
    static CSS = { label: 'CSS', category: 'frontend', color: '#3a9bd9' };
    static JAVASCRIPT = { label: 'JavaScript', category: 'frontend', color: '#f7df1e' };
    static TYPESCRIPT = { label: 'TypeScript', category: 'frontend', color: '#4a9eef' };
    static VITE = { label: 'Vite', category: 'frontend', color: '#a48bff' };
    static ELECTRON = { label: 'Electron', category: 'mobile', color: '#757083' };

    static PYTHON = { label: 'Python', category: 'scripting', color: '#ffdb27' };
    static CSHARP = { label: 'C#', category: 'desktop', color: '#a78bfa' };
    static DOTNET = { label: '.NET 8', category: 'desktop', color: '#9b8bff' };
    static WINUI = { label: 'WinUI 3', category: 'desktop', color: '#4a9eef' };
    static WPF = { label: 'WPF', category: 'desktop', color: '#9b8bff' };
    static DOTNET_FRAMEWORK = { label: '.NET Framework', category: 'desktop', color: '#9b8bff' };
    static WINDOWS_FORMS = { label: 'Windows Forms', category: 'desktop', color: '#4a9eef' };

    static CAPACITOR = { label: 'Capacitor', category: 'mobile', color: '#25a31c' };
    static REACT_NATIVE = { label: 'React Native', category: 'mobile', color: '#61dafb' };
    static EXPO_CLI = { label: 'Expo CLI', category: 'mobile', color: '#9b8bff' };
    static ANDROID_NATIVE = { label: 'Android nativo', category: 'mobile', color: '#3ddc84' };
    static SWIFT = { label: 'Swift', category: 'mobile', color: '#f05138' };
    static GODOT = { label: 'Godot', category: 'mobile', color: '#478cbf' };

    static NODE_JS = { label: 'Node.js', category: 'backend', color: '#8cc84b' };
    static EXPRESS_JS = { label: 'Express JS', category: 'backend', color: '#88c97f' };
    static SPRING_BOOT = { label: 'Spring Boot', category: 'backend', color: '#8acf5b' };
    static JAVA = { label: 'Java', category: 'backend', color: '#ed8b00' };

    static MONGODB = { label: 'MongoDB', category: 'database', color: '#5fbb60' };
    static INDEXEDDB = { label: 'IndexedDB', category: 'database', color: '#4285f4' };
    static FIREBASE = { label: 'Firebase', category: 'database', color: '#ffca28' };

    static TMDB = { label: 'TMDB', category: 'service', color: '#01b4e4' };
    static GEMINI = { label: 'Gemini', category: 'service', color: '#8b5cf6' };
    static MCP = { label: 'MCP', category: 'service', color: '#d97757' };
    static IA = { label: 'IA', category: 'service', color: '#c4a8ff' };
    static WEB_CRYPTO_API = { label: 'Web Crypto API', category: 'service', color: '#9aa0a6' };
}

export default Technologies;
